module.exports = __webpack_public_path__ + "img/tank-vertical-unselected.ac7d7bcc.svg";